import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CmsArticle, CmsCollection, CmsContentType, CmsTeaser, CmsViewType } from '@fcom/core-api';

@Component({
  selector: 'cms-articles-with-icons',
  templateUrl: './cms-articles-with-icons.component.html',
  styleUrls: ['./cms-articles-with-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmsArticlesWithIconsComponent implements OnInit {
  protected readonly CmsContentType = CmsContentType;
  protected readonly CmsViewType = CmsViewType;

  @Input()
  content$: Observable<CmsCollection>;

  articles$: Observable<CmsArticle[]>;
  link$: Observable<CmsTeaser>;

  ngOnInit(): void {
    this.articles$ = this.content$.pipe(
      map((collection) => collection.items.filter((i) => i.contentType === CmsContentType.CMArticle) as CmsArticle[])
    );
    this.link$ = this.content$.pipe(
      map((collection) => collection.items.find((i) => i.contentType === CmsContentType.CMTeaser) as CmsTeaser),
      filter(Boolean)
    );
  }
}
